import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import UndesiredWorkConditionForm from 'components/UndesiredWorkConditionForm'
import { notificationApi } from 'hooks/api/notification'
import { useSnackbar } from 'hooks/useSnackbar/SnackbarContext'
import { SecurityInsightType, UndesiredWorkConditionData } from 'types/insight'

export default function UndesiredWorkConditionPage() {
  const { t } = useTranslation('page-insight-undesired-work')
  const { showSnackbar } = useSnackbar()
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [initialData, setInitialData] = useState<
    Partial<UndesiredWorkConditionData>
  >({})

  const params = new URLSearchParams(window.location.search)
  const notificationId = params.get('notificationId') ?? undefined

  useEffect(() => {
    if (!notificationId) return

    notificationApi()
      .findInsightById(notificationId)
      .then((res) => {
        const data = res.data.data
        if (
          data &&
          (data.coWorker ||
            data.workSite ||
            (data.businessDivision && data.businessDivision.length > 0) ||
            data.distance ||
            data.numberOfCoWorkers ||
            data.numberOfCoWorkersDetail ||
            data.pattern ||
            data.other)
        ) {
          setInitialData(data)
          setIsSubmitted(true)
        }
      })
      .catch((error) => {
        console.error('Failed to load existing data:', error)
      })
  }, [notificationId])

  const handleSubmit = async (data: UndesiredWorkConditionData) => {
    if (!notificationId || isSubmitted) return

    await notificationApi()
      .upsertInsightData(notificationId, {
        data,
        insightType: SecurityInsightType.UndesiredWorkCondition,
      })
      .then(() => {
        setIsSubmitted(true)
        setInitialData(data)
      })
      .catch((error) => {
        console.error('Failed to submit data:', error)
        showSnackbar(t('submit_error'), 'error')
      })
  }

  return (
    <UndesiredWorkConditionForm
      onSubmit={handleSubmit}
      isSubmitted={isSubmitted}
      initialData={initialData}
    />
  )
}
